import axios from "axios";
const API_URL = "https://vestshop-api.vercel.app/api"

//REGISTER
export const handleRegister = async (user) => {
    try {
        const res = await axios.post(`${API_URL}/register`, user)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
//LOGIN
export const handleLogin = async (user) => {
    try {
        const res = await axios.post(`${API_URL}/login` , user)
        return res.data
    } catch (Err) {
        console.log(Err)
    }
}
// GET EACH USER
export const handleGetUser = async (id) => {
    try {
        const res = await axios.get(`${API_URL}/getUser/${id}`)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
// UPDATE USER
export const handleUpdateUser = async (id, user) => {
    try {
        const res = await axios.put(`${API_URL}/updateUser/${id}`, user)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
// PUSH ADDRESS
export const handlePushAddress = async (id, address) => {
    try {
        const res = await axios.put(`${API_URL}/pushAddress/${id}`, address)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
// UPDATE ADDRESS
export const handlUpdateAddress = async (id, newAddress) => {
    try {
        const res = await axios.put(`${API_URL}/updateAddress/${id}`, newAddress)
        console.log(res.data)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
// GET ADDRESS
export const handleGetAddress = async (id) => {
    try {
        const res = await axios.get(`${API_URL}/getUser/${id}`)
        return res.data
    } catch (err) {
        console.log(err)
    }
}
// DELETE ADDRESS
export const handleDeleteAddress = async (id, postCode) => {
    console.log(id, postCode)
    try {
        const res = await axios.put(`${API_URL}/deleteAddress/${id}`, { code: postCode })
        return res.data
    } catch (err) {
        console.log(err)
    }
}
